import {
  ORDER_METHODS,
  ORDER_REJECTED_REASON,
  PaymentMethod,
  RoomServiceLocationType
} from "../../../../services/exports/Constants";

export default {
  header: {
    order_canceled: "Order canceled",
    track_order: "Your order",
    order_info: 'Order info & updates are sent to your email {{email}}',
  },
  order_status: {
    order_canceled: "Order canceled",
    confirmed_time: {
      text: 'Confirmed {{type}}:',
      type_labels: {
        [ORDER_METHODS.ROOM_SERVICE]: 'time',
        [ORDER_METHODS.PICKUP]: 'pickup time',
        [ORDER_METHODS.DELIVERY]: 'delivery time',
      },
    },
    estimated_time: {
      text: 'Estimated {{type}}:',
      type_labels: {
        [ORDER_METHODS.ROOM_SERVICE]: 'time',
        [ORDER_METHODS.PICKUP]: 'pickup time',
        [ORDER_METHODS.DELIVERY]: 'delivery time',
      },
    },
  },
  order_type: {
    pickup: "pickup",
    delivery: "delivery",
  },
  labels: {
    today: 'Today',
  },
  order_status_toast: {
    order_reviewed: "#{{number}} Your order has been seen",
    order_confirmed: "#{{number}} Confirmed time {{time}}",
    order_preparation_up_time_changed:
      "#{{number}} {{type}} time changed to {{time}}",
    order_preparing: "Your order #{{number}} is being prepared",
    order_rejected: "#{{number}} order rejected",
  },
  warning_label: {
    order_rejected_reason: {
      [ORDER_REJECTED_REASON.AUTOMATIC]:
        "Unfortunately, we are currently facing overwhelming demand and can't prepare your order in time. We already sent your money back and you should receive it within 4 working days at the latest. If you do not receive the money within 4 days, please write to our digital partner {{provider}} at {{supportEmail}}. We apologize for this and would be happy if you try to order again in an 1 hour  in case you can wait. If you have any questions, please call the restaurant.",
      [ORDER_REJECTED_REASON.CLOSING_SOON]:
        "Unfortunately, we don’t have time to make your order before we close today. We already sent your money back and you should receive it within 4 working days at the latest. If you do not receive the money within 4 days, please write to our digital partner {{provider}} at {{supportEmail}}. If you have any questions, please call the restaurant.",
      [ORDER_REJECTED_REASON.ITEM_UNAVAILABLE]:
        "Unfortunately, we cannot currently offer the item(s) you ordered. We already sent your money back and you should receive it within 4 working days at the latest. If you do not receive the money within 4 days, please write to our digital partner {{provider}} at {{supportEmail}}. If you have any questions, please call the restaurant.",
      [ORDER_REJECTED_REASON.ORDER_TOO_BIG]:
        "Unfortunately, we cannot prepare your order in time. If it’s okay, please try again with smaller order(s). We already sent your money back and you should receive it within 4 working days at the latest. If you do not receive the money within 4 days, please write to our digital partner {{provider}} at {{supportEmail}}. If you have any questions, please call the restaurant.",
      [ORDER_REJECTED_REASON.CUSTOMER_MISTAKE]: '',
      [ORDER_REJECTED_REASON.OTHER]: '',
    },
    pickup_time_changed:
      "{{company}} changed the time from {{initialTime}} to {{currentTime}}",
  },
  room_service_instructions: {
    title: 'Instructions',
    location_types: {
      [RoomServiceLocationType.RoomService]: 'Room service, number {{details}}',
      [RoomServiceLocationType.TableService]: 'Table service, number {{details}}',
    },
    location_types_without_number: {
      [RoomServiceLocationType.RoomService]: 'Room service',
      [RoomServiceLocationType.TableService]: 'Table service',
    },
  },
  pickup_instructions: {
    title: "Pickup Instructions",
    description: "🗣 Tell us your order number when you pick up your order.",
  },
  delivery_instructions: {
    title: "Delivery instructions",
    address: "Your address",
    note: "Note: ",
  },
  rewards: {
    title: "Your rewards",
  },
  order_details: {
    title: "Order details",
  },
  payment_breakdown: {
    free: "Free",
    deal_applied: "Deal applied",
    points_applied: "Points applied",
    promo_applied: "Promo applied",
  },
  price_details: {
    title: "Price details",
    original: "Original",
    tip: "Tip",
    total: "Total",
    delivery_fee: "Delivery fee",
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal fee',
    },
    service_fee: "Online processing",
    tax: 'Taxes',
  },
  review_form: {
    title: "How do you like {{name}}?",
    description: "Your feedback is anonymous and helps us improve.",
  },
  upload_google_review: {
    title: "Review us & get rewarded",
  },
  toast_messages: {
    share_experience: "How do you like us? Please share below 😊",
  },
  error_messages: {
    failed_to_load: "Failed to load order. Please try again.",
  },
};
